import introJs from "intro.js";

import * as Intro from './_IntroBase';

export function settlementFilterAutoStart() {
    if (!window.SettingsManager.getAttribute('settlementFilterIntro')) {
        settlementFilterStartIntro();
    }
}

export function settlementFilterStartIntro() {
    initSettlementFilterSteps();
    
    introJs()
        .setOption('exitOnOverlayClick', 'false')
        .setOption('prevLabel', 'Előző')
        .setOption('nextLabel', 'Következő')
        .setOption('skipLabel', 'x')
        .setOption('doneLabel', 'x')
        .setOption('showBullets', false)
        .onexit(function () {
            window.SettingsManager.setAttribute('settlementFilterIntro', true);
        })
        .start();
}

function initSettlementFilterSteps() {
    let allStepCount: number = 4;
    let currentStep: number;

    let $infoButton = $('#settlement-filter-intro-first-step');
    Intro.initFirstStepTemplateHeader($infoButton, allStepCount);

    currentStep = 2;
    let $table_ = $('#settlement-filter-settings');
    $table_.attr('data-step', currentStep);
    $table_.attr('data-position', 'right');
    $table_.attr('data-intro',
        Intro.introTemplateHeader('Kedvenc települések', currentStep, allStepCount)
        + 'Ide kattintva bármikor beállíthatja azokat a településeket, melyekkel Önnek ténylegesen feladata van. A megjelölt települések ügyei és iratai külön megjeleníthetőek lesznek. Ebben a választó listában csak azokat a településeket látja, amik a hatóság illetékességi területéhez tartoznak. A fejlécben lévő négyzetbe kattintva az összes települést kijelölheti, majd a következő kattintással az összes kijelölést törölheti.'
    );

    currentStep = 3;
    let $filterSwitch = $('#settlement-filter');
    $filterSwitch.attr('data-step', currentStep);
    $filterSwitch.attr('data-position', 'right');
    $filterSwitch.attr('data-intro',
        Intro.introTemplateHeader('Nézet választó', currentStep, allStepCount)
        + 'Ezzel a gombbal választhat, hogy a hatóság illetékességi területe szerinti összes települést, vagy csak a beállított, kedvenc településeket érintő ügyek és iratok jelenjenek meg a táblázatban.'
    );

    let $lastStep = $('#settlement-filter-wrapper');
    Intro.initLastStepTemplateHeader($lastStep, allStepCount);
}
